module.exports = __webpack_public_path__ + "img/l_d3.7f2d695f.png";